import Swiper from "swiper/bundle";

const iconTextSlider = document.querySelector(".related-product-slider");
if (iconTextSlider) {
  const swiper = new Swiper(iconTextSlider, {
    direction: "horizontal",
    loop: false,
    spaceBetween: 26,
    centeredSlides: false,
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: false,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 26,
      },
      400: {
        slidesPerView: 1,
        spaceBetween: 26,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 26,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 26,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 26,
      },
    },
  });
}
 
